/**
 * Client-side locale plumbing: ISO locale labels for language pickers.
 *
 * `languageDefinitions` maps each ISO locale to a display label and flag
 * emoji, used by language pickers and moderation cards. Date-format helpers
 * (`getDayjsLocaleFromIso`, `getLocaleDateFormat`, `getLocaleTimeOfDayFormat`)
 * live in `@repo/shared/date`.
 */

import { type IsoLocale } from '@repo/shared/locale';
import type { TLabel } from 'util/stdtypes';
import { t } from 'util/stdtypes';

export type LanguageDefinition = {
    label: TLabel;
    emoji?: string;
};

export const languageDefinitions: Record<IsoLocale, LanguageDefinition> = {
    'en-US': { label: t('language.en-US', 'English'), emoji: '🇬🇧' },
    'fr-FR': { label: t('language.fr-FR', 'French'), emoji: '🇫🇷' },
    'fr-CH': { label: t('language.fr-CH', 'French (Swiss)'), emoji: '🇫🇷🇨🇭' },
    'fr-CA': { label: t('language.fr-CA', 'French (Canadian)'), emoji: '🇫🇷🇨🇦' },
    'fr-BE': { label: t('language.fr-BE', 'French (Belgian)'), emoji: '🇫🇷🇧🇪' },
    'de-DE': { label: t('language.de-DE', 'German'), emoji: '🇩🇪' },
    'de-CH': { label: t('language.de-CH', 'German (Swiss)'), emoji: '🇩🇪🇨🇭' },
    'it-IT': { label: t('language.it-IT', 'Italian'), emoji: '🇮🇹' },
    'it-CH': { label: t('language.it-CH', 'Italian (Swiss)'), emoji: '🇮🇹🇨🇭' },
    'rm-CH': { label: t('language.rm-CH', 'Romansh (Swiss)'), emoji: '🇨🇭' },
    'nl-NL': { label: t('language.nl-NL', 'Dutch'), emoji: '🇳🇱' },
};
